import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDeviceConfigurationPerFleet } from '../../services/DeviceService';
import { DeviceFleetConfiguration } from '../../types/Devices';

function useGetDeviceConfigurationPerFleet(fleetId: string): UseQueryResult<DeviceFleetConfiguration> {
  return useQuery(
    ['device-fleet-configuration', fleetId],
    async (): Promise<DeviceFleetConfiguration> => getDeviceConfigurationPerFleet(fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      enabled: !!fleetId,
    },
  );
}

export default useGetDeviceConfigurationPerFleet;
